module.exports = __webpack_public_path__ + "static/img/cont64 (8).a618067.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont64 (8).jpg
// module id = KnM+
// module chunks = 0